var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.677,
    height: 12.451,
    viewBox: "0 0 18.677 12.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-sort",
    "data-name": "Icon material-sort",
    d: "M10.5,21.451h6.226V19.376H10.5ZM4.5,9v2.075H23.177V9Zm3,7.263H19.951V14.188H7.5Z",
    transform: "translate(-4.5 -9)",
    fill: "#4a4a4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/Icon_Filter.22b15384.svg";
export { ForwardRef as ReactComponent };